import React from "react";
import { DashboardCardData } from "./cardContent";
import { Col, Row } from "antd";
import media from "../../../../media";

const TopCard = () => {
  const dashboardCardData = [
    {
      slug: "new_orders",
      title: "Total Ordered Items",
      img: media.ak_new_order,
      bgClass: "bg-light-warning",
      titleClass: "text-warning",
      tooltipTitle: (
        <div className="font-size-xs">
          Total number of product units ordered this month across all orders.
          <br />
          <div className="font-italic text-muted">
            Example: <br />
            Order1 (A×3) + Order2 (A×2, B×4) <br />= 9 units
          </div>
        </div>
      ),
    },
    {
      slug: "delivered_items",
      title: "Delivered Items",
      img: media.ak_total_delivered,
      bgClass: "bgi-no-repeat",
      titleClass: "text-dark-75",
      numberClass: "text-success",
      bgStyle: {
        backgroundImage: `url(${media.dashboardcard_bg})`,
        backgroundPosition: "left top",
        backgroundSize: "30% auto",
      },
      tooltipTitle: (
        <div className="font-size-xs">
          Total number of product units successfully delivered this month.
          <br />
          <div className="font-italic text-muted">
            Example: <br />
            Order1 (A×3) + Order2 (B×2) <br />= 5 units delivered
          </div>
        </div>
      ),
    },
    {
      slug: "cancelled_items",
      title: "Cancelled Items",
      img: media.cancelled_items,
      bgClass: "bg-light-warning",
      titleClass: "text-warning",
      tooltipTitle: (
        <div className="font-size-xs">
          Total number of product units cancelled this month across all orders.
          <br />
          <div className="font-italic text-muted">
            Example: <br />
            Order1 (A×2) + Order3 (C×1) <br />= 3 units cancelled
          </div>
        </div>
      ),
    },
    {
      slug: "returned_items",
      title: "Returned Items",
      img: media.returned_items,
      bgClass: "bgi-no-repeat",
      titleClass: "text-dark-75",
      numberClass: "text-success",
      bgStyle: {
        backgroundImage: `url(${media.dashboardcard_bg})`,
        backgroundPosition: "left top",
        backgroundSize: "30% auto",
      },
      tooltipTitle: (
        <div className="font-size-xs">
          Total number of product units returned to vendor this month.
          <br />
          <div className="font-italic text-muted">
            Example: <br />
            Order2 (B×1) + Order4 (A×2) <br />= 3 units returned
          </div>
        </div>
      ),
    },
    {
      slug: "gross_earnings",
      title: "Gross Earnings",
      img: media.ak_gross_earning,
      bgClass: "bg-light-warning",
      tooltipTitle: (
        <div className="font-size-xs">
          Gross earnings are calculated based on the final settlement value
          received for each order this month (after adjustments, commissions, or
          deductions if applicable)..
          <br />
          <div className="font-italic text-muted">
            Example: <br />
            Order1 (₹500) sv (₹430) + Order2 (₹1,200) sv (₹1100) + Order3 (₹800)
            sv (₹720) <br />= ₹2,250 gross earnings
          </div>
        </div>
      ),
    },
    // {
    //   slug: "total_products",
    //   title: "Total Products",
    //   img: media.ak_total_product,
    //   bgClass: "bg-light-warning",
    //   titleClass: "text-warning",
    // },
  ];
  return (
    <div className="today_list">
      <Row gutter={[12, 12]}>
        {dashboardCardData.map((card, index) => (
          <Col key={index} className="gutter-row" flex="1">
            <DashboardCardData
              slug={card.slug}
              cardTitle={card.title}
              cardImg={card.img}
              bgClass={card.bgClass}
              cardTitleClass={card.titleClass}
              cardNumberClass={card.numberClass}
              bgStyle={card.bgStyle}
              tooltipTitle={card.tooltipTitle}
            />
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default TopCard;
